const PercentIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6"
      cy="6"
      r="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="18"
      cy="18"
      r="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="6"
      y1="18"
      x2="18"
      y2="6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default PercentIcon;
